import React from "react";
import { StyleSheet, TouchableOpacity } from "react-native";

import Icon from "components/Icon";
import Text from "components/Text";

import { colors, sizes } from "assets/constants";
import { useRecoilValue } from "recoil";
import { authAtom } from "stores";

export default function Tag(props: {
  title?: string;
  value?: string;
  renderContent?: () => JSX.Element;
  onPress?: () => void;
}) {
  const {
    company: { color },
  } = useRecoilValue(authAtom);

  return (
    <TouchableOpacity
      onPress={props.onPress}
      activeOpacity={props.onPress ? sizes.tapOpacity : 1}
      style={styles.container}
    >
      {props.renderContent ? (
        props.renderContent()
      ) : (
        <>
          <Icon size={15} name="x" />

          {props?.value !== "" && (
            <Text color={color || colors.textColorDefault} style={styles.value}>
              {props?.value}
            </Text>
          )}
          {props?.title !== "" && <Text>{props?.title}: </Text>}
        </>
      )}
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    height: sizes.tagHeight,
    paddingHorizontal: 7,
    borderWidth: 1,
    borderRadius: 9,
    borderColor: colors.border,
    backgroundColor: colors.white,
  },

  value: { marginLeft: 7 },
});
